/**
 * Bus d'événements minimal.
 *
 * Sert à ce que la file de synchronisation prévienne l'interface qu'elle a
 * changé, sans que le noyau connaisse le DOM. Vingt lignes, pas de dépendance,
 * pas de « state management ».
 */
export type NomEvenement =
  | 'file-changee'
  | 'zonage-change'
  | 'reseau-change'
  | 'patrouille-changee'
  | 'saison-changee'
  | 'theme-change'

type Ecouteur = () => void

const abonnes = new Map<NomEvenement, Set<Ecouteur>>()

/** Retourne la fonction de désabonnement. */
export function surEvenement(nom: NomEvenement, f: Ecouteur): () => void {
  let ensemble = abonnes.get(nom)
  if (!ensemble) {
    ensemble = new Set()
    abonnes.set(nom, ensemble)
  }
  ensemble.add(f)
  return () => {
    ensemble.delete(f)
  }
}

export function emettre(nom: NomEvenement): void {
  const ensemble = abonnes.get(nom)
  if (!ensemble) return
  for (const f of [...ensemble]) {
    try {
      f()
    } catch (e) {
      // Un écouteur qui casse ne doit jamais empêcher les autres de tourner,
      // et surtout jamais interrompre une saisie de terrain.
      console.error('[kwata] écouteur en échec sur', nom, e)
    }
  }
}
